import PropTypes from 'prop-types'
import React from 'react'
import ContentWrapper from '../components/ContentWrapper'
import Footer from '../components/Footer'
import Header from '../components/Header'
import NextPageOffer from '../components/NextPageOffer'
import OffcanvasMenu from '../components/OffcanvasMenu'
import PageTransition from '../components/PageTransition'

const TemplateWrapper = ({ children, location, lang, stickyHeader, nextPage, hideHeader, invertLogo }) => {
  return (
    <>
      <PageTransition location={location} />
      <OffcanvasMenu location={location} lang={lang} />
      {!hideHeader && (
        <Header siteTitle="Neoskop" location={location} lang={lang} sticky={stickyHeader} invertLogo={invertLogo} />
      )}
      <ContentWrapper>{children}</ContentWrapper>
      <Footer location={location} lang={lang} />
      <NextPageOffer to={nextPage.to} title={nextPage.title} />
    </>
  )
}

TemplateWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.object,
  lang: PropTypes.string,
  stickyHeader: PropTypes.bool,
  nextPage: PropTypes.shape({
    to: PropTypes.string,
    title: PropTypes.string
  }).isRequired,
  hideHeader: PropTypes.bool,
  invertLogo: PropTypes.bool
}

TemplateWrapper.defaultProps = {
  lang: 'de',
  stickyHeader: true,
  nextPage: {
    to: '/agentur',
    title: 'Lerne uns kennen'
  },
  hideHeader: false,
  invertLogo: false
}

export default TemplateWrapper
